import { useState } from 'react';
import {
  RosterPill,
  FontAwesomeIcon,
  TeamRoles,
  TeamRoleEnum,
} from '@rivallapp/volosports-components';
import classNames from 'classnames/bind';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';

import { useRegistrationData } from '../../../../../hooks';
import { GenderOptions } from '../../../../../shared/gender-enum';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

const WhoIsPlaying = () => {
  const { programRoster } = useRegistrationData();
  const [showPlayers, setShowPlayers] = useState(false);

  const displayGender = gender => GenderOptions.find(({ value }) => value === gender);

  return (
    <div>
      <div
        onClick={() => setShowPlayers(!showPlayers)}
        onKeyDown={() => setShowPlayers(!showPlayers)}
        role="button"
        tabIndex={0}
        className="row"
      >
        <div className={cx('programTitle', 'col-7')}>Registered Players</div>
        <div className="d-flex justify-content-end col-4">
          <FontAwesomeIcon
            icon={!showPlayers ? faChevronDown : faChevronUp}
            colorScheme="black"
            size="13px"
          />
        </div>
      </div>
      {showPlayers ? (
        <div className={cx('pickup-players-container')}>
          {programRoster.length ? (
            programRoster?.map(({ userId, gender, picture, userDisplayInfo }) => (
              <RosterPill
                key={userId}
                isPickup
                displayName={userDisplayInfo?.displayName}
                email={userDisplayInfo?.displayEmail}
                phone_number={userDisplayInfo?.displayPhone}
                teamRole={TeamRoles[TeamRoleEnum.TEAM_MEMBER].label}
                gender={displayGender(gender)?.display}
                {...{ userId, picture }}
              />
            ))
          ) : (
            <p className="m-2">No one&apos;s playing yet.</p>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default WhoIsPlaying;
